export enum XtMotionStatusDetails {
  RESOLUTION = 'Video must be 1920x1080 or 1280x720',
  FPS = 'Video must have a framerate of 23.97, 24, 25, 29.97, 30, 50, 59.94 or 60',
  SIZE = 'Video must be less than 500Mb',
  DURATION = 'The length of the video must be less than 10 seconds',
  FORMAT = 'The video must be in mp4 or MXF-OP1A format',
  UPLOAD = 'An error occurred during the upload',
  UNKNOWN = 'Video not supported',
  ROTATION = 'Video must be in landscape format',
  DEFAULT = '',
  SUCCESS = "You'll receive an email shortly to download your XtraMotion processed video",
}

export enum XtMotionStatus {
  DEFAULT = '',
  ANALYZING = "We're analyzing your video, please wait it might take some time...",
  PROGRESS = "Your file is valid. We're now uploading your video, please wait...",
  FAILURE = 'Oops, something went wrong',
  SUCCESS = 'Thanks for trying out XtraMotion',
}
